import moment from 'moment'

export default class PoPreferenceDomain {
	/**
	 * Handles the default constructor
	 * @param {boolean} poRequired - is a PO required
	 * @param {boolean} beforeAfter - before/after flag
	 * @param {string} ccRequired - credit card required code
	 * @param {number} poId - id
	 * @param {boolean} isBillToPreference - is this from the bill-to account
	 * @param {boolean} isReadOnly - is this object readOnly
	 * @param {string} createdAt - created date
	 * @param {string} updatedAt - updated date
	 * @returns {AccountNumbersDomain} - returns the new AccountNumbersDomain object
	 */

	constructor(poRequired, beforeAfter, ccRequired, poId, isBillToPreference, isReadOnly, createdAt, updatedAt) {
		this.poRequired = poRequired 
		this.beforeAfter = beforeAfter 
		this.ccRequired = ccRequired 
		this.poId = poId 
		this.isBillToPreference = isBillToPreference
		this.isReadOnly = isReadOnly
		this.createdAt = moment(createdAt)
		this.updatedAt = moment(updatedAt)
	}
}


// WEBPACK FOOTER //
// ./src/domains/PoPreferenceDomain.js